import { render, staticRenderFns } from "./OfferDialog.vue?vue&type=template&id=5480e406&scoped=true&"
import script from "./OfferDialog.vue?vue&type=script&lang=js&"
export * from "./OfferDialog.vue?vue&type=script&lang=js&"
import style0 from "./OfferDialog.vue?vue&type=style&index=0&id=5480e406&prod&scoped=true&lang=css&"
import style1 from "./OfferDialog.vue?vue&type=style&index=1&id=5480e406&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5480e406",
  null
  
)

export default component.exports